var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatteryConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.18 55.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.87,9.85l-6.22,6.22a10,10,0,0,1-1.54,12.14l-5.54,5.54L21.43,19.61c.05,0,5.5-5.5,5.54-5.54a10,10,0,0,1,12.14-1.54l6.22-6.22L39,0H16.16L0,16.16V39l6.31,6.31,6.22-6.22A10,10,0,0,1,14.07,27s5.5-5.49,5.54-5.54L33.75,35.57l-5.54,5.54a10,10,0,0,1-12.14,1.54L9.85,48.87l6.31,6.31H39L55.18,39V16.16Z",
    fill: "#0e7f19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.07,27a10,10,0,0,0-1.54,12.14L6.31,45.33l3.54,3.54,6.22-6.22a10,10,0,0,0,12.14-1.54l5.54-5.54L19.61,21.44Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.33,6.31l-6.22,6.22A10,10,0,0,0,27,14.07s-5.49,5.5-5.54,5.54L35.57,33.75l5.54-5.54a10,10,0,0,0,1.54-12.14l6.22-6.22Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryConnected);
export default __webpack_public_path__ + "static/media/battery-connected.3fb1a55d51610b8791eec3f2b78024d0.svg";
export { ForwardRef as ReactComponent };